module.exports = __webpack_public_path__ + "static/media/industry-partners-third.8331656e.jpg";